import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, authState } from '@angular/fire/auth';
import { map, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth   = inject(Auth);
  const router = inject(Router);

  return authState(auth).pipe(
    take(1),
    map(firebaseUser => {
      const user = firebaseUser ?? auth.currentUser;
      const returnUrl = state.url;
      if (!user) {
        return router.createUrlTree(['/login'], { queryParams: { returnUrl } });
      }
      if (!user.emailVerified) {
        return router.createUrlTree(['/verificar-email'], { queryParams: { returnUrl } });
      }
      return true;
    }),
  );
};
